import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { Switch, InputRef, App, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useClickAway } from "ahooks";
import cls from "classnames";
import { MODEL_SWITCH, ResCode } from "logic/src/constants/request";
import { modifyModelSwitch } from "logic/src/services/auth";

import SJModal from "@/components/SJModal";
import SJButton from "@/components/SJButton";
import authVM from "logic/src/businesses/auth/vm";

import styles from "./index.module.scss";

const UserSetting: React.FC<{
  open: boolean;
  onClose: () => void;
  resetInit: () => void;
}> = ({ open, onClose, resetInit }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { message, modal } = App.useApp();
  const codeWrapRef = useRef<HTMLDivElement>(null);
  const codeInputRef = useRef<InputRef>(null);

  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    setIsEdit(false);
  }, [open]);

  useEffect(() => {
    isEdit ? codeInputRef.current?.focus() : codeInputRef.current?.blur();
  }, [isEdit]);

  useClickAway(() => {
    setIsEdit(false);
  }, codeWrapRef.current);

  // 更改模型优化开关
  const handleSwitchChange = async (isChecked: boolean) => {
    authVM.user.switchModel(
      isChecked ? MODEL_SWITCH.ABLE : MODEL_SWITCH.DISABLED,
    );
  };
  // 注销确认
  const handleLogoff = () => {
    onClose();
    modal.confirm({
      title: t("sensechat-34"), // 确认注销账号吗？
      okText: t("sensechat-57"), //  确定
      autoFocusButton: null,
      centered: true,
      content: t("sensechat-35"), // 注销后信息将永久删除且无法使用哦
      okButtonProps: { className: "sj-button", size: "small", type: "dashed" },
      cancelText: t("sensechat-21"), // 取消
      cancelButtonProps: {
        className: "sj-button",
        size: "small",
        type: "primary",
      },
      onOk() {
        requestshowLogoff();
      },
      onCancel() {
        console.log("cancel logoff");
      },
    });
  };
  // 注销
  const requestshowLogoff = async () => {
    try {
      await authVM.logoff();
      await resetInit();
      message.success(t("sensechat-53")); // 注销成功
    } catch (error) {
      // messageApi.destroy(loadingId);
    }
  };

  return (
    <SJModal
      width={488}
      open={open}
      footer={null}
      title={t("sensechat-89")} // "其他设置"
      onCancel={onClose}
    >
      <div className={styles.container}>
        <div className={styles.item}>
          {/* 对话数据用于优化模型 */}
          <span className={styles.text}>{t("sensechat-32")}</span>
          <Switch
            checked={authVM.user.userInfo?.model_switch === MODEL_SWITCH.ABLE}
            onChange={handleSwitchChange}
            className={cls(
              styles.switch,
              authVM.user.userInfo?.model_switch === MODEL_SWITCH.ABLE &&
                styles["switch-active"],
            )}
          />
        </div>
        <div className={styles.item}>
          {/* 对话数据用于优化模型 */}
          <span className={styles.text}>人工智能生成内容标识公告</span>
          <Button size="small" onClick={() => navigate("/notice")}>
            查看
          </Button>
        </div>

        <div className={styles.item}>
          {/* 注销账号 */}
          <span className={styles.text}>{t("sensechat-5")}</span>
          <SJButton size="small" danger type="primary" onClick={handleLogoff}>
            {t("sensechat-246")}
          </SJButton>
        </div>
      </div>
    </SJModal>
  );
};
export default observer(UserSetting);
